export const REGION = 'us-west-2';
export const USER_POOL_ID = 'us-west-2_yNrTmOtCo';
export const APP_CLIENT_ID = '3e9pb2irci6h8h2km381upac7b';
export const IDENTITY_POOL_ID = 'us-west-2:2fb97c7d-ef29-47e3-8280-a29a70864768';
export const COGNITO_DOMAIN = 'ee-portal-auth-prod.auth.us-west-2.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'prod';
export const APPEAL_ENABLED = 'false';